<template lang="pug">
  v-card
    v-card-title
      h2.modal-title {{ isEditMode ? $t('base.edit') : $t('base.create_farm') }}
    v-card-content
      v-input-r(
        :label="$t('base.name')"
        :hint="errorMessage('name')"
        :invalid="!!errorMessage('name')"
        :pattern="'.{1,100}'"
        v-model="form.name"
        @blur="validateName")
      v-select(
        :label="$t('history.timezone')"
        :options="options.timezones"
        :hint="errorMessage('timezone')"
        :invalid="!!errorMessage('timezone')"
        itemValue="value"
        v-model="form.timezone"
        @blur="validateTimezone")
    v-card-actions
      v-btn(
        :disabled="!isValid"
        :loading="loading"
        @click="onSubmit")
        | {{ isEditMode ? $t('base.save') : $t('base.add') }}
</template>

<script>
import api from '@/api'
import formErrorsMixin from '@/mixins/form-errors.mixin.js'
export default {
  name: 'DetailModal',
  mixins: [formErrorsMixin],
  props: {
    selected: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    form: {
      name: null,
      timezone: null,
      // language: null
    },
    options: {
      timezones: [],
      langs: [
        { id: 0, name: 'Українська', key: 'uk' },
        { id: 1, name: 'Русский', key: 'ru' },
        { id: 2, name: 'Polski', key: 'pl' },
        { id: 3, name: 'English', key: 'en' },
        { id: 4, name: 'Eesti', key: 'et' },
        { id: 5, name: 'Ελληνικά', key: 'el' },
        { id: 6, name: 'Español', key: 'es' },
        { id: 7, name: 'Español (US)', key: 'es-us' },
        { id: 8, name: 'Netherlands', key: 'nl' },
        { id: 9, name: 'Deutsch', key: 'de' },
        { id: 10, name: 'Français', key: 'fr' },
        { id: 11, name: 'Italiano', key: 'it' },
        { id: 12, name: 'Română', key: 'ro' },
        { id: 13, name: 'USA', key: 'us' },
      ]
    },
    errors: {
      name: null,
      timezone: null
    },
    loading: false
  }),

  computed: {
    lang () {
      return this.$store.getters['account/lang']
    },

    isEditMode () {
      return this.selected !== null
    },

    isValid () {
      return this.form.name &&
      this.form.timezone
    }
  },

  watch: {
    'form.name' (newValue) {
      if (this.errors.name && newValue && newValue.length > 0 && newValue.length <= 100) {
        this.errors.name = null
      }
    },
    'form.timezone' (newValue) {
      if (this.errors.timezone && newValue) {
        this.errors.timezone = null
      }
    }
  },

  async mounted () {
    this.loadOptions()
    if (this.isEditMode) {
      this.form.name = this.selected.name
      const { data } = await api.farms.getById(this.selected.id)
      // this.form.language = data.language
      this.form.timezone = data.timezone
    }
  },

  methods: {
    validateName () {
      this.checkValidData()
    },

    validateTimezone () {
      this.errors.timezone = null
      if (!this.form.timezone) {
        this.errors.timezone = ['3'] // required
      }
    },

    forceValidation () {
      this.checkValidData()
      this.validateTimezone()

      if (this.errors.name) {
        const inputComponent = this.$children.find(child => child.$options.name === 'VInputR')
        if (inputComponent) {
          inputComponent.hasBlurred = true
        }
      }

      if (this.errors.timezone) {
        const selectComponent = this.$children.find(child => child.$options.name === 'VSelect')
        if (selectComponent) {
          selectComponent.hasBlurred = true
        }
      }
    },

    async onSubmit () {
      this.forceValidation()

      if (this.errors.name !== null || this.errors.timezone !== null) {
        return
      }

      this.loading = true
      const payload = {
        name: this.form.name,
        // language: this.form.language,
        timezone: this.form.timezone,
        company: {
          id: this.$route.params.company_id
        }
      }

      const { errors } = this.isEditMode
        ? await api.farms.updateById(this.selected.id, payload)
        : await api.farms.create(payload)
      this.errors = errors
      if (!errors) {
        this.$emit('close')
        this.$emit('update')
      }
      this.loading = false
    },

    checkValidData () {
      this.errors.name = null
      if (!this.form.name) {
        this.errors.name = ['3']
      } else if (this.form.name.length > 100) {
        this.errors.name = ['6', 100]
      }
    },

    async loadOptions () {
      const { data } = await api.local.timezones()
      this.options.timezones = Object
        .entries(data)
        .filter((item) => {
          if (this.lang === 'us') {
            return item[0].includes('America')
          } else return true
        })
        .map(item => ({
          name: `(${item[1]}) ${item[0]}`,
          value: item[0]
        }))
    }
  }
}
</script>
<style scoped>
.v-card__title {
  padding: 2rem 2.4rem 1.6rem;
}

.modal-title {
  font-size: 2rem;
  font-weight: 700;
  margin: 0;
}

.v-card__content {
  border-top: .1rem solid #d7d7d7;
  padding-bottom: 1.5rem !important;
}

.v-card__actions {
  padding: 0 2.4rem 2.4rem;
}

.v-card__actions button {
  width: 100%;
}
</style>